import './src/base/fonts/fonts.css';

const DEFAULT_LANG = 'pl';
const SUPPORTED_LANGS = ['pl', 'en'];
const LANGUAGE_STORAGE_KEY = 'preferred-language';

const getPreferredLanguage = () => {
	const storedLang = localStorage.getItem(LANGUAGE_STORAGE_KEY);
	if (storedLang && SUPPORTED_LANGS.includes(storedLang)) {
		return storedLang;
	}

	const browserLang = navigator.language?.split('-')[0] || DEFAULT_LANG;
	return SUPPORTED_LANGS.includes(browserLang) ? browserLang : DEFAULT_LANG;
};

export const onClientEntry = () => {
	const currentPath = window.location.pathname;
	const pathSegments = currentPath.split('/').filter(Boolean);
	const firstSegment = pathSegments[0];

	const hasLangPrefix = SUPPORTED_LANGS.includes(firstSegment);

	if (!hasLangPrefix) {
		const preferredLang = getPreferredLanguage();

		if (preferredLang !== DEFAULT_LANG) {
			const newPath = `/${preferredLang}${currentPath}`;
			window.location.replace(newPath);
		}
	}
};
